// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundPanel__container-e86cd2 {
  display: flex;
  flex-direction: column;
  width: 360px;
  height: 100%;
}

.BackgroundPanel__content-a47b84 {
  margin: 16px;
}

.BackgroundPanel__blur-block-ff7fd1 {
  margin-top: 16px;
}

.BackgroundPanel__blur-title-cd8075 {
  font: var(--font-subtitle-1);
  letter-spacing: var(--font-spacing-subtitle-1);
  color: var(--addition-50);
  margin-bottom: 4px;
}

.BackgroundPanel__blur-list-ec73de {
  display: flex;
}

.BackgroundPanel__blur-item-d337e9 {
  width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 12px;
  margin-inline-end: 8px;
  cursor: pointer;
}

.BackgroundPanel__blur-item-d337e9 svg {
  fill: var(--addition-50);
}

.BackgroundPanel__blur-item-active-d57735 {
  border: 2px solid var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/AnimatedBackgroundPanel/components/BackgroundPanel/BackgroundPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,oCAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 360px;\n  height: 100%;\n}\n\n.content {\n  margin: 16px;\n}\n\n.blur-block {\n  margin-top: 16px;\n}\n\n.blur-title {\n  font: var(--font-subtitle-1);\n  letter-spacing: var(--font-spacing-subtitle-1);\n  color: var(--addition-50);\n  margin-bottom: 4px;\n}\n\n.blur-list {\n  display: flex;\n}\n\n.blur-item {\n  width: 76px;\n  height: 76px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  border-radius: 12px;\n  margin-inline-end: 8px;\n  cursor: pointer;\n}\n\n.blur-item svg {\n  fill: var(--addition-50);\n}\n\n.blur-item-active {\n  border: 2px solid var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BackgroundPanel__container-e86cd2`,
	"content": `BackgroundPanel__content-a47b84`,
	"blur-block": `BackgroundPanel__blur-block-ff7fd1`,
	"blurBlock": `BackgroundPanel__blur-block-ff7fd1`,
	"blur-title": `BackgroundPanel__blur-title-cd8075`,
	"blurTitle": `BackgroundPanel__blur-title-cd8075`,
	"blur-list": `BackgroundPanel__blur-list-ec73de`,
	"blurList": `BackgroundPanel__blur-list-ec73de`,
	"blur-item": `BackgroundPanel__blur-item-d337e9`,
	"blurItem": `BackgroundPanel__blur-item-d337e9`,
	"blur-item-active": `BackgroundPanel__blur-item-active-d57735`,
	"blurItemActive": `BackgroundPanel__blur-item-active-d57735`
};
module.exports = ___CSS_LOADER_EXPORT___;
